export const BANNER_DATA = {
  text: "",
  cta_text: "",
  cta_link: "",
  pages: ["/dashboard"],
};

export const BANNER_IMAGES = [
  "/assets/banner1.png",
  "/assets/banner2.png",
  "/assets/banner3.png",
  // "/assets/banner4.png",
  // "/assets/banner-blast.png",
];

export const KERNEL_BANNER_DATA = {
  text1: "",
  text2: "",
  cta_text: "",
  cta_link: "",
};
